export const comparators = {
    eq: "eq",
    existsNeq: "existsNeq",
    includes: "includes",
    doesNotExist: "doesNotExist"
}